import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const AZUL = [37, 99, 235];
const brl = (v) => `R$ ${(Number(v) || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

function cabecalho(doc, empresa, titulo, sub) {
  doc.setFillColor(...AZUL);
  doc.rect(0, 0, 210, 26, "F");
  let tx = 14;
  if (empresa?.logo) {
    try { doc.addImage(empresa.logo, "PNG", 12, 4, 18, 18); tx = 34; } catch (e) { /* ignore */ }
  }
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text(empresa?.nome || "Casa de Repouso São Jorge", tx, 12);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(`CNPJ: ${empresa?.cnpj || "-"}`, tx, 18);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(titulo, 196, 12, { align: "right" });
  if (sub) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.text(sub, 196, 18, { align: "right" });
  }
  doc.setTextColor(30, 41, 59);
}

// Soma mensalidade e 13º das faturas PAGAS de um residente no ano informado
function rendimentoAno(faturasResidente, ano) {
  let mensalidade = 0;
  let decimo = 0;
  faturasResidente
    .filter((f) => f.paga && (f.mes || "").startsWith(String(ano)))
    .forEach((f) => {
      const linhas = [...(f.extras || []), ...((f.manual || []).filter((m) => m.parte === "mensal"))];
      linhas.forEach((e) => {
        const d = (e.descricao || "").toLowerCase();
        if (d.includes("13")) decimo += Number(e.valor) || 0;
        else if (d.includes("mensalidade")) mensalidade += Number(e.valor) || 0;
      });
    });
  return { mensalidade, decimo, total: mensalidade + decimo };
}

export function gerarInformeRendimentosLotePDF({ empresa, residentes, faturas, ano }) {
  const doc = new jsPDF();
  cabecalho(doc, empresa, "INFORME DE RENDIMENTOS", `Ano-base ${ano}`);
  let primeira = true;

  const ativos = [...residentes].sort((a, b) => a.nome.localeCompare(b.nome));

  ativos.forEach((r) => {
    const fatsRes = faturas.filter((f) => f.residenteId === r.id);
    const rend = rendimentoAno(fatsRes, ano);

    if (!primeira) doc.addPage();
    primeira = false;

    let y = 34;
    doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.setTextColor(30, 41, 59);
    doc.text(r.nome, 14, y); y += 7;
    doc.setFont("helvetica", "normal"); doc.setFontSize(9.5); doc.setTextColor(71, 85, 105);
    doc.text(`Quarto: ${r.quarto || "-"}   ·   CPF: ${r.cpf || "-"}`, 14, y); y += 5;
    if (r.responsavel) { doc.text(`Responsável: ${r.responsavel}`, 14, y); y += 5; }
    y += 4;

    autoTable(doc, {
      startY: y,
      head: [["Discriminação", "Valor pago no ano"]],
      body: [
        ["Mensalidades pagas", brl(rend.mensalidade)],
        ["13º pago", brl(rend.decimo)],
      ],
      foot: [["Total dos rendimentos", brl(rend.total)]],
      theme: "striped",
      headStyles: { fillColor: AZUL, textColor: 255 },
      footStyles: { fillColor: [241, 245, 249], textColor: [30, 41, 59], fontStyle: "bold" },
      styles: { fontSize: 9.5, cellPadding: 3 },
      columnStyles: { 1: { halign: "right" } },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;

    doc.setFont("helvetica", "italic"); doc.setFontSize(8); doc.setTextColor(148, 163, 184);
    doc.text(
      "Considera apenas mensalidade e 13º de faturas quitadas. Materiais, medicamentos e serviços não compõem o informe de rendimentos.",
      14, y, { maxWidth: 182 }
    );
  });

  if (primeira) {
    // nenhum residente
    doc.setFontSize(11); doc.setTextColor(148, 163, 184);
    doc.text("Nenhum residente para gerar o informe.", 14, 40);
  }

  doc.save(`informe_rendimentos_${ano}.pdf`);
}
